<template lang="pug">
    div.banner-wide-skyscraper( :class="{ 'banner-leaderboard--fixed' : fixed }" )
        div.banner-wide-skyscraper__temp
</template>

<script>
    export default {
        name: "BannerWideSkyscraper",
        props: {
            fixed: Boolean
        }
    }
</script>

<style scoped lang="scss">
    
    $module: 'banner-wide-skyscraper';
    $module-height: 114px;

    .#{$module} {
        
        &__temp {
            width: 160px;
            height: 600px;
            background-color: #ccc;
            border: 1px solid #000;
        }
    }
</style>